<BolideLoader v-if="is_redirecting" />

<main class="auth-page min-vh-100 bg-light">
  <div class="container min-vh-100 d-flex align-items-center py-5">
    <div class="auth-panel row g-0 w-100 justify-content-center shadow-lg rounded-4 overflow-hidden bg-white">
      <section class="auth-brand-panel col-lg-6 text-white p-4 p-md-5 d-none d-lg-flex flex-column">
        <router-link to="/login" class="d-inline-flex bg-white rounded-3 p-3 shadow" aria-label="Department of Basic Education login">
          <span class="auth-logo d-block" aria-hidden="true"></span>
        </router-link>

        <div class="my-auto py-5">
          <p class="text-uppercase small text-white-50 fw-semibold mb-2">Secure verification</p>
          <h1 class="display-6 fw-bold mb-3">One more step to the DBE dashboard.</h1>
          <p class="text-white-50 mb-0">
            Enter the verification code sent to your email to securely complete your sign in.
          </p>
        </div>
      </section>

      <section class="col-lg-6 p-4 p-md-5 d-flex align-items-center">
        <div class="mx-auto w-100 py-lg-4" style="max-width: 28rem;">
          <router-link to="/login" class="d-flex d-lg-none justify-content-center mb-4" aria-label="Department of Basic Education login">
            <span class="auth-logo auth-logo-navbar d-block" aria-hidden="true"></span>
          </router-link>

          <h2 class="h3 fw-bold mb-2">Check your email</h2>
          <p class="text-secondary mb-4">
            We sent a 6-digit security code to <strong>{{ email }}</strong>.
          </p>

          <SnackbarMessage
            :error-message="error_message"
            :success-message="success_message"
            @dismiss-error="error_message = ''"
            @dismiss-success="success_message = ''"
          />

          <div v-if="is_loading" class="d-flex align-items-center justify-content-center gap-2 text-secondary py-4">
            <span class="spinner-border spinner-border-sm text-primary" aria-hidden="true"></span>
            <span>Verifying code...</span>
          </div>

          <form v-if="!is_loading" @submit.prevent="submit_otp">
            <div class="d-flex justify-content-between gap-2 mb-4 otp-inputs">
              <input
                v-for="(digit,index) in otp"
                :key="index"
                v-model="otp[index]"
                maxlength="1"
                inputmode="numeric"
                autocomplete="one-time-code"
                class="form-control form-control-lg text-center fw-semibold otp-input-box"
                @input="handle_input(index,$event)"
                @paste="handle_paste(index,$event)"
                @keydown.backspace="handle_backspace(index,$event)"
              />
            </div>

            <button class="btn btn-primary w-100 py-2 mb-3 d-inline-flex align-items-center justify-content-center gap-2">
              Verify code
              <i class="bi bi-arrow-right" aria-hidden="true"></i>
            </button>

            <p class="text-center text-secondary small mb-2">
              Didn't receive the code?
              <button type="button" class="btn btn-link text-primary fw-semibold p-0 text-decoration-none" @click="resend_otp">
                Resend OTP
              </button>
            </p>

            <p class="text-center text-secondary small mb-3">
              You can resend in <strong>{{ formatted_timer }}</strong>
            </p>

            <p class="text-center small mb-0">
              <router-link to="/login" class="text-decoration-none fw-semibold text-primary">
                <i class="bi bi-arrow-left me-1" aria-hidden="true"></i> Back to login
              </router-link>
            </p>
          </form>
        </div>
      </section>
    </div>
  </div>
</main>
